import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = { min: Number, max: Number }

  connect() {
    this.update()
  }

  update() {
    const { label, tone } = this.#status(this.inputTarget.value.length)

    this.counterTarget.textContent = label
    this.counterTarget.classList.toggle("text-red-600", tone === "invalid")
    this.counterTarget.classList.toggle("text-green-600", tone === "valid")
  }

  #status(length) {
    if (this.maxValue) {
      return { label: `${length} characters (Max ${this.maxValue})`, tone: length > this.maxValue ? "invalid" : "neutral" }
    }

    return { label: `${length} characters (Min ${this.minValue})`, tone: length < this.minValue ? "invalid" : "valid" }
  }
}
